<script type="text/javascript">
// 定义一些公共的属性和方法
// const remoteIp = "http://www.ccmypg.org.cn";
// const remoteIp = "http://121.4.92.63:8088";
// const remoteIp = "http://www.rcedu.org.cn";
const remoteIp = "http://www.rcedu.org.cn";
let plates = [];
//从右到左滚动
function srcollpic(x, y, z) {
  var speed = 30;
  var demo2 = document.getElementById(x);
  var demo1 = document.getElementById(y);
  var demo = document.getElementById(z);
  demo2.innerHTML = demo1.innerHTML;

  function Marquee() {
    if (demo2.offsetWidth - demo.scrollLeft <= 0)
      demo.scrollLeft -= demo1.offsetWidth;
    else {
      demo.scrollLeft++;
    }
  }
  var MyMar = setInterval(Marquee, speed);
  demo.onmouseover = function() {
    clearInterval(MyMar);
  };
  demo.onmouseout = function() {
    MyMar = setInterval(Marquee, speed);
  };
}
function isPhone() {
  var mobile = navigator.userAgent.match(
    /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
  );
  return mobile != null;
}
function getPlates() {
  if (plates.length == 0) {
    this.$axios
      .get("/api/categorys?page=1&limit=30")
      .then((res) => {
        plates = res.data.data;
        console.log("getPlates return " + JSON.stringify(plates));
        return Promise.resolve(plates);
      })
      .catch((err) => {
        return Promise.reject(err.response.data.error);
      });
  } else {
    return Promise.resolve(plates);
  }
}
function sortByTop(arr) {
  for (var i = 0; i < arr.length; i++) {
    if (arr[i].top == "1") {
      arr.unshift(arr[i]);
      arr.splice(i + 1, 1);
      break;
    }
  }
  return arr;
}
function loadScript(src, callback){
    var script = document.createElement('script'),
        head = document.getElementsByTagName('head')[0];
    script.type = 'text/javascript';
    script.charset = 'UTF-8';
    script.src = src;
    if (script.addEventListener) {
        script.addEventListener('load', function () {
            callback();
        }, false);
    } else if (script.attachEvent) {
        script.attachEvent('onreadystatechange', function () {
            var target = window.event.srcElement;
            if (target.readyState == 'loaded') {
                callback();
            }
        });
    }
    head.appendChild(script);
}

// 暴露出这些属性和方法
export default {
  remoteIp,
  srcollpic,
  getPlates,
  sortByTop,
  isPhone,
  loadScript
};
</script>
